import { render, staticRenderFns } from "./GerenciarEmpenhoSIAF.vue?vue&type=template&id=4e4044f2&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarEmpenhoSIAF.vue?vue&type=style&index=0&id=4e4044f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4044f2",
  null
  
)

export default component.exports